import { render } from "./agree.vue?vue&type=template&id=06a9b43c&ts=true"
import script from "./agree.vue?vue&type=script&lang=ts&config=true"
export * from "./agree.vue?vue&type=script&lang=ts&config=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__